import { useEffect, useState } from "react";
import PrepareFetch from "../helpers/PrepareFetch";
import { LuckyNumberPromoListFacades } from "../helpers/LuckyNumberFacades";
import { Skeleton, Typography } from "@mui/material";
import alertSkeleton from "../assets/icons/alertSkeleton.svg";
import LuckyNumberPromoListContainer from "../atom/LuckyNumberPromoList";
import LuckyNumberPromoItem from "../atom/LuckyNumberPromoItem";

const LuckyNumberPromoList = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [data, setData] = useState([]);
    const [availablePromo, setAvailablePromo] = useState([]);
    const [endedPromo, setEndedPromo] = useState([]);

    useEffect(() => {
        let fetchParams = PrepareFetch(`/proxy/services/apexrest/api/v1/luckynumber/promotions`,"GET",{
            "cache-by": "user"
        });

        (async () => {
            await fetch(fetchParams.url, fetchParams.options)
                    .then(response => {
                        if(response.status === 200) {
                          return response.json();
                        }
      
                        throw new Error(response);
                    })
                    .then(json => {
                        setLoading(false);
                        setData(LuckyNumberPromoListFacades(json));
                        console.log(json, data);
                    })
                    .catch(error => {
                        setLoading(false);
                        setError(true);
                    });
          })();
    },[]);

    useEffect(() => {
        setAvailablePromo(data.filter(promo => !promo.isEnded));
        setEndedPromo(data.filter(promo => promo.isEnded));
    },[data]);

  return (
    <LuckyNumberPromoListContainer>
        {loading && (
            <>
                <Skeleton variant="text" sx={{ fontSize: "1.5rem", maxWidth: "20rem", borderRadius: ".5rem"}} className="twoColumn"></Skeleton>
                <Skeleton
                    variant="rectangular"
                    className="skeleton"
                />
                <Skeleton
                    variant="rectangular"
                    className="skeleton"
                />
            </>
        )}
        {!loading && !error && (
            <>
                {data.length === 0 && (
                    <div className="warningBlock">
                        <img src={alertSkeleton} alt="" />
                        Não há campanhas vigentes.
                    </div>
                )}
                {data.length > 0 && (
                    <>
                        {availablePromo.length > 0 && (
                            <>
                                <p className='twoColumn'>Confira as campanhas vigentes</p>
                                {availablePromo.map((item) => (
                                    <LuckyNumberPromoItem data={item} key={item.id}></LuckyNumberPromoItem>
                                ))}
                            </>
                        )}
                        {endedPromo.length > 0 && (
                            <>
                                <p className='twoColumn'>Campanhas encerradas</p>
                                {endedPromo.map((item) => (
                                    <LuckyNumberPromoItem data={item} key={item.id}></LuckyNumberPromoItem>
                                ))}
                            </>
                        )}
                    </>
                )}
            </>
        )}
        {!loading && error && (
            <div className="warningBlock">
                <img src={alertSkeleton} alt="" />
                Não foi possível carregar o conteúdo.
            </div>
        )}
    </LuckyNumberPromoListContainer>
  );
};

export default LuckyNumberPromoList;